export const BRAND = {
  name: "JOBLSX",
  tagline: "Professional Digital Consulting & Account Management",
  email: "joblsx.consulting@gmail.com",
  instagram: "joblsx",
  instagramUrl: "https://instagram.com/joblsx",
  whatsappNumber: "+91 98676 42892",
  whatsappDigits: "919867642892",
  hours: "Monday – Saturday · 10:00 AM – 8:00 PM",
};

export const whatsappLink = (text = "Hi JOBLSX, I'd like to know more about your services.") =>
  `https://wa.me/${BRAND.whatsappDigits}?text=${encodeURIComponent(text)}`;

export const SERVICES = [
  {
    key: "account-management",
    title: "Account Management",
    desc: "Professional assistance with managing online accounts efficiently and securely.",
    icon: "LayoutDashboard",
  },
  {
    key: "growth-strategy",
    title: "Growth Strategy",
    desc: "Personalized consulting and planning focused on sustainable, long-term growth objectives.",
    icon: "TrendingUp",
  },
  {
    key: "profile-audit",
    title: "Profile Audit",
    desc: "Detailed analysis with clear, actionable recommendations intended to help improve account quality.",
    icon: "SearchCheck",
  },
  {
    key: "platform-issue-analysis",
    title: "Platform Issue Analysis",
    desc: "Review account issues with guidance based on public platform features and policies.",
    icon: "ShieldAlert",
  },
  {
    key: "technical-support",
    title: "Technical Support",
    desc: "Help diagnose common technical issues and suggest practical solutions.",
    icon: "Wrench",
  },
  {
    key: "one-on-one",
    title: "One-on-One Consulting",
    desc: "Private consulting sessions tailored for individuals and businesses.",
    icon: "Users",
  },
  {
    key: "reputation-management",
    title: "Reputation Management",
    desc: "Ongoing profile positioning and reputation consulting for micro-celebrities, creators, and public figures.",
    icon: "Star",
  },
];

export const REPUTATION = {
  overline: "Micro-Celebrity Management",
  title: "Reputation management for rising public figures.",
  desc: "We partner with micro-celebrities, creators, streamers, and emerging public figures to manage their digital reputation with care. From consistent profile positioning to respectful audience communication, our guidance keeps your public presence professional, cohesive, and aligned with platform policies.",
  points: [
    { icon: "UserCheck", title: "Profile Positioning", text: "A consistent, credible presence across your key profiles." },
    { icon: "MessagesSquare", title: "Audience Communication", text: "Guidance on respectful, on-brand engagement with your community." },
    { icon: "ShieldCheck", title: "Reputation Monitoring", text: "Advisory review of public mentions and profile perception." },
    { icon: "LifeBuoy", title: "Response Guidance", text: "Calm, practical support when sensitive situations arise." },
  ],
};

export const WHY = [
  { title: "Professional Consulting", icon: "BadgeCheck" },
  { title: "Fast Response", icon: "Zap" },
  { title: "Personalized Solutions", icon: "Sparkles" },
  { title: "Privacy Focused", icon: "Lock" },
  { title: "Transparent Communication", icon: "MessageSquare" },
  { title: "Client First Approach", icon: "HeartHandshake" },
];

export const PROCESS = [
  { step: "01", title: "Consultation", desc: "We listen to your goals and current challenges." },
  { step: "02", title: "Account Review", desc: "A thorough audit of your profile and setup." },
  { step: "03", title: "Strategy Planning", desc: "A tailored roadmap built around your needs." },
  { step: "04", title: "Implementation Guidance", desc: "Step-by-step support as you execute." },
  { step: "05", title: "Ongoing Support", desc: "Continued guidance to sustain momentum." },
];

export const FAQS = [
  {
    q: "How do consultations work?",
    a: "Consultations begin with a discovery conversation where we understand your goals. From there we review your account, identify opportunities, and outline a clear, actionable plan you can follow with our guidance.",
  },
  {
    q: "Do you offer personalized guidance?",
    a: "Yes. Every engagement is tailored to your specific situation. We do not use one-size-fits-all templates — recommendations are shaped around your platform, audience, and objectives. All guidance is advisory and aligned with the applicable platform's public terms and policies.",
  },
  {
    q: "How quickly can I receive support?",
    a: "We pride ourselves on fast response times. Most inquiries receive a first reply within a few business hours, and consulting sessions can typically be scheduled within a few days.",
  },
  {
    q: "How do I book a consultation?",
    a: "Simply use the Book Consultation button anywhere on the site, or reach out via WhatsApp or the contact form. We'll confirm a time that works for you.",
  },
];

export const TESTIMONIALS = [
  {
    name: "A. Rivera",
    role: "Content Creator",
    country: "United States",
    rating: 5,
    text: "The audit gave me a clear, honest picture of what needed to change. The guidance was practical and easy to follow.",
  },
  {
    name: "M. Chen",
    role: "Small Business Owner",
    country: "Singapore",
    rating: 5,
    text: "Responsive, transparent, and genuinely helpful. I finally understood how to manage my accounts with confidence.",
  },
  {
    name: "S. Okafor",
    role: "Gamer & Streamer",
    country: "Nigeria",
    rating: 5,
    text: "The growth strategy session was worth every minute. No hype, just a realistic plan I could actually execute.",
  },
  {
    name: "L. Novak",
    role: "Freelance Professional",
    country: "Czechia",
    rating: 5,
    text: "Privacy-focused and professional throughout. Their process felt structured and reassuring from start to finish.",
  },
  {
    name: "R. Kapoor",
    role: "Micro-Influencer",
    country: "India",
    rating: 5,
    text: "The reputation management guidance kept my profiles consistent and professional. Communication was always clear.",
  },
  {
    name: "T. Alvarez",
    role: "Startup Founder",
    country: "Spain",
    rating: 5,
    text: "A calm, methodical partner. They explained every recommendation and respected our platform's policies throughout.",
  },
  {
    name: "K. Yamamoto",
    role: "Digital Creator",
    country: "Japan",
    rating: 5,
    text: "Fast responses and thoughtful advice. The one-on-one consulting helped me prioritise what actually mattered.",
  },
  {
    name: "D. Smith",
    role: "Community Manager",
    country: "United Kingdom",
    rating: 5,
    text: "Professional from first contact. The profile audit surfaced issues I hadn't noticed and gave me a clear path forward.",
  },
];

export const DISCLAIMER =
  "JOBLSX provides consulting, account management, technical guidance, and optimization services only. We do not guarantee account recovery, verification, policy exceptions, or outcomes controlled by third-party platforms. Recommendations should comply with the applicable platform's terms and policies.";
